document.addEventListener('DOMContentLoaded', () => {
  function formatDate2(date) {
    const options = { weekday: 'long', day: '2-digit', month: '2-digit' };
    const formatted = date.toLocaleDateString('fr-FR', options);
    return formatted.charAt(0).toUpperCase() + formatted.slice(1);
  }

  function addBusinessDays(date, businessDaysToAdd) {
    let result = new Date(date);
    let added = 0;
    while (added < businessDaysToAdd) {
      result.setDate(result.getDate() + 1);
      const day = result.getDay();
      if (day !== 0 && day !== 6) added++;
    }
    return result;
  }

  const today = new Date();
  const start = addBusinessDays(today, 1);
  const end = addBusinessDays(today, 2);

  document.querySelectorAll('.custom-buy-box').forEach((box) => {
    const startEl = box.querySelector('.shipping-start');
    const endEl = box.querySelector('.shipping-end');
    if (startEl && endEl) {
      startEl.textContent = formatDate2(start);
      endEl.textContent = formatDate2(end);
    }
  });
});
